namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;

    export interface IPortalService {
        delete(portal: pms.Portal): angular.IPromise<boolean>;
		getById(id: string): angular.IPromise<pms.Portal>;
		getByPortalGroupId(portalGroupId: string): angular.IPromise<pms.Portal[]>;
		getDetailsById(id: string, session?: boolean): angular.IPromise<pms.Portal>;
		getHistory(id: string, spinner?: string): angular.IPromise<pms.Portal[]>;
        save(portal: pms.Portal): angular.IPromise<pms.Portal>;
		saveDetails(portal: pms.Portal): angular.IPromise<pms.Portal>;
    }

    @Service('app', 'portalService')
	@Inject('$q', 'apiService', 'serverConstants', 'storageService')
    export class PortalService implements IPortalService {
        constructor(
            private $q: angular.IQService,
			private apiService: IApiService,
			private serverConstants: pmi.IServerConstants,
            private storageService: IStorageService
        ) { }

        delete(portal: pms.Portal): angular.IPromise<boolean> {
            const endpoint = `/portal/${portal.id}`;

            return this.apiService.deleteItem(endpoint).then((response: boolean) => {
                return response;
            });
        }

		getById(id: string): angular.IPromise<pms.Portal> {
            const endpoint = `/portal/${id}`;

            return this.apiService.getItem<pms.Portal>(endpoint).then((response: pms.IPortal) => {
                return new pms.Portal(response);
            });
        }

		getByPortalGroupId(portalGroupId: string): angular.IPromise<pms.Portal[]> {
            const endpoint = `/portalbyportalgroupid/${portalGroupId}`;

            return this.apiService.getItem<pms.Portal[]>(endpoint).then((response: pms.IPortal[]) => {
                const portals: pms.Portal[] = [];

                for (const portal of response) {
                    portals.push(new pms.Portal(portal));
                }

                return portals;
            });
        }

		getDetailsById(id: string, useStorage: boolean = true): angular.IPromise<pms.Portal> {
            const endpoint = `/portaldetails/${id}`;

			let timestamp: Date = useStorage ? new Date(this.storageService.getItem<Date>(pm.StorageType.Local, `portal-${id}-timestamp`)) : null;
			let portal: pms.Portal = useStorage && this.serverConstants.connectTo !== 'Qa' && timestamp >= this.serverConstants.tsPortal ? this.storageService.getItem<pms.Portal>(pm.StorageType.Local, `portal-${id}-details`) : null;

            const promise = portal ?
                this.$q.when(portal) :
                this.apiService.getItem<pms.Portal>(endpoint);

            return promise.then((response: pms.IPortal) => {
                portal = new pms.Portal(response);

				if (useStorage) {
					this.storageService.saveItem<pms.Portal>(pm.StorageType.Local, `portal-${id}-details`, portal);
					this.storageService.saveItem<Date>(pm.StorageType.Local, `portal-${id}-timestamp`, this.serverConstants.tsPortal);
				}

				return portal;
            });
        }

		getHistory(id: string, spinner: string = null): angular.IPromise<pms.Portal[]> {
			const endpoint = `/portalhistory/${id}`;

			return this.apiService.getItem<pms.Portal[]>(endpoint, spinner).then((response: pms.Portal[]) => {
				const portals: pms.Portal[] = [];

				for (const portal of response) {
					portals.push(new pms.Portal(portal));
				}

				return _.orderBy(portals, ['createdOn'], ['desc']);
			});
		}

		save(portal: pms.Portal): angular.IPromise<pms.Portal> {
			const endpoint = `/portal`;

			return this.apiService.saveItem<pms.Portal, pms.Portal>(endpoint, portal).then((response: pms.IPortal) => {
				return new pms.Portal(response);
			});
		}

		saveDetails(portal: pms.Portal): angular.IPromise<pms.Portal> {
			const endpoint = `/portaldetails`;

			return this.apiService.saveItem<pms.Portal, pms.Portal>(endpoint, portal).then((response: pms.IPortal) => {
				return new pms.Portal(response);
			});
		}
    }
}